import { DatePickerSelectInput } from 'components/Inputs';

import { Stack } from '@mui/material';

export const TreatmentConsultationFilter: React.FC = () => {
  return (
    <Stack spacing={1} direction="row">
      <DatePickerSelectInput
        size="small"
        name="startDate"
        label="Data Início"
        InputProps={{ fullWidth: false, sx: { width: 180 } }}
      />

      <DatePickerSelectInput
        size="small"
        name="endDate"
        label="Data Término"
        InputProps={{ fullWidth: false, sx: { width: 180 } }}
      />
    </Stack>
  );
};
